import { useGetAssigneesMutation } from 'src/services/Utils';
import { useSendEmailMutation } from 'src/services/emailActivityAPI';
export const useEmailActivity = () => {
  const [
    getUsersBasedOnPermission,
    {
      data: userData,
      error: userDataError,
      isError: userDataIsError,
      isSuccess: userDataIsSuccess,
      isLoading: userDataIsLoading
    }
  ] = useGetAssigneesMutation();
  const [
    sendEmail,
    {
      data: sendEmailData,
      error: sendEmailError,
      isError: sendEmailIsError,
      isSuccess: sendEmailIsSuccess,
      isLoading: sendEmailIsLoading
    }
  ] = useSendEmailMutation();
  return {
    getUsersBasedOnPermission,
    userData,
    userDataError,
    userDataIsError,
    userDataIsSuccess,
    userDataIsLoading,
    sendEmail,
    sendEmailData,
    sendEmailError,
    sendEmailIsError,
    sendEmailIsSuccess,
    sendEmailIsLoading
  };
};
